var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 10.7368H21.0596L22.9687 4.71168C23.3121 3.62368 23.1387 2.41758 22.5012 1.48705C21.8637 0.556526 20.8301 0 19.7404 0H17C16.4951 0 16.0174 0.23621 15.6927 0.64421L7.7027 10.7368H3.4C1.5249 10.7368 0 12.342 0 14.3158V30.4211C0 32.3948 1.5249 34 3.4 34H26.0219C26.7136 33.9976 27.3883 33.7742 27.9569 33.3595C28.5254 32.9448 28.961 32.3582 29.206 31.6773L33.8929 18.5228C33.9641 18.3219 34.0003 18.1092 34 17.8947V14.3158C34 12.342 32.4751 10.7368 30.6 10.7368ZM3.4 14.3158H6.8V30.4211H3.4V14.3158ZM30.6 17.5708L26.0219 30.4211H10.2V13.1741L17.7956 3.57895H19.7438L17.0884 11.9591C17.0022 12.228 16.9782 12.5148 17.0183 12.7955C17.0584 13.0762 17.1615 13.3428 17.319 13.5732C17.4766 13.8036 17.684 13.9912 17.9242 14.1203C18.1644 14.2494 18.4303 14.3165 18.7 14.3158H30.6V17.5708Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.c63d69847e278042a67ab504a1edb937.svg";
export { ForwardRef as ReactComponent };